import { AddDescription } from "./AddDescription";
import { AddImage } from "./AddImage";
import { CreateBenefit } from "./CreateBenefit";
import { UpdateBenefit } from "./UpdateBenefit";
import { CreateBarcodesLimit } from "./CreateBarcodesLimit";
import { UpdateBarcodesLimit } from "./UpdateBarcodesLimit";
import { BenefitStatistics } from "./BenefitStatistics";

export default [
    {name: 'UpdateBarcodesLimit', title:"UpdateBarcodesLimit", component: UpdateBarcodesLimit},
    {name: 'CreateBarcodesLimit', title:"CreateBarcodesLimit", component: CreateBarcodesLimit},
    {name: 'BenefitStatistics', title: "BenefitStatistics", component: BenefitStatistics},
    {name: 'AddDescription', title:"Add description", component: AddDescription},
    {name: 'AddImage', title:"AddImage", component: AddImage},
    {name: 'UpdateBenefit', title:"UpdateBenefit", component: UpdateBenefit},
    {name: 'CreateBenefit', title:"CreateBenefit", component: CreateBenefit},
];
